//faq like Nav menu dropdown
document.querySelectorAll(`.sliderNavMenuTitle`).forEach(function (element) {
    element.addEventListener("click", function () {
        this.parentElement.classList.toggle("active");
    });
});

/**************
 Mobile Nav
 ***************/

// open nav
function openNav() {
    document.querySelector("#slider").classList.add("active");
    document.querySelector("body").classList.add("noScroll");
}

// close nav
function closeNav() {
    document.querySelector("#slider").classList.remove("active");
    document.querySelector("body").classList.remove("noScroll");
}

// open nav event listener
document.querySelectorAll(".openNav").forEach(function (element) {
    element.addEventListener("click", openNav);
});

//close nav event listener
document.querySelectorAll(".closeNav").forEach(function (element) {
    element.addEventListener("click", closeNav);
});